'use client';

import { ReactNode, Ref, forwardRef, useEffect, useState } from "react";
// Import Swiper React components
import { Swiper as SwiperJS, SwiperProps, SwiperSlideProps } from 'swiper/react';
import { SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { twMerge } from 'tailwind-merge';

interface Props {
  slides: ReactNode[];
  className?: string;
  wrapperClassName?: string;
  swiperProps?: Partial<SwiperProps>;
  swiperSlideProps?: Partial<SwiperSlideProps>;
}

const Swiper = forwardRef(({ slides, className, wrapperClassName, swiperProps, swiperSlideProps }: Props, ref: any) => {
  const [init, setInit] = useState(false);
  return (
    <div className={twMerge('w-full relative flex flex-col gap-[24px]', wrapperClassName)}>
      <SwiperJS
        modules={[Autoplay, Pagination]}
        spaceBetween={0}
        // slidesPerView={2}
        speed={1750}
        centeredSlides
        onInit={() => {
          const swiper = ref.current?.swiper;
          if (swiper) {
            swiper.autoplay.stop();
            setTimeout(() => swiper.autoplay?.start(), 6000)
          }
          setInit(true);
        }}
        loop
        dir='rtl'
        breakpoints={{
          0: {
            slidesPerView: 'auto',
            centeredSlides: true
          },
          768: {
            slidesPerView: 'auto',
            centeredSlides: true
          },
          1024: {
            slidesPerView: 3.15,
            centeredSlides: true,
          },

        }}

        // allowTouchMove={false}
        autoplay={{
          delay: 2000
        }}
        pagination={
          {
            dynamicBullets: true,
            dynamicMainBullets: 1,
            el: '.swiper-custom-pagination',
            type: 'bullets',
            clickable: true,
          }
        }
        {...swiperProps}
        className={twMerge('w-full', swiperProps?.className)}
        wrapperClass={twMerge('w-full !items-center [&>*]:!grid [&>*]:!place-items-center tablet:[&>*]:!block [&>*]:!w-fit [&>*]:pl-[24px] [&>*:last-child]:pl-0', className)}
        ref={ref}
      >
        {init ? slides.map((s, i) => <SwiperSlide key={i} {...swiperSlideProps} className='w-full min-w-[300px] max-w-[300px] tablet:max-w-[350px] tablet:min-w-[350px] desktop:w-[30%] desktop:min-w-[30%] desktop:max-w-[420px]'>{s}</SwiperSlide>) : null}
      </SwiperJS>

      <div className="swiper-custom-pagination" />
    </div>
  )
});


export default Swiper;